
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchFloorFinderService, filterCarpetService } from "../services/floorMatcherService";

export const fetchFloorFinder = createAsyncThunk(
  "carpetFinder/fetchFloorFinder",
  async (filters, { rejectWithValue }) => {
    try {
      return await fetchFloorFinderService(filters);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const filterCarpet = createAsyncThunk(
  "carpetFinder/filterCarpet",
  async (options, { rejectWithValue }) => {
    try {
      return await filterCarpetService(options);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// floorFinderSlice Slice

const floorFinderSlice = createSlice({
  name: "floorFinder",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // fetchFloorFinder
      .addCase(fetchFloorFinder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFloorFinder.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchFloorFinder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // filterCarpet
      .addCase(filterCarpet.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(filterCarpet.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(filterCarpet.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default floorFinderSlice.reducer;
